// AppInitializer.js
import { useEffect } from "react";
import { useAuth } from "./providers/AuthProvider";
import use123zapStore from "../context/123zapStore";

export default function AppInitializer({ children }) {
  const { isAuthenticated } = useAuth();
  const loadPlanoAtual = use123zapStore((s) => s.loadPlanoAtual);

  useEffect(() => {
    if (isAuthenticated) {
      loadPlanoAtual(true);
    }
  }, [isAuthenticated, loadPlanoAtual]);

  return children;
}
